import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import {Player, Bid} from '../../models/player';
import { SharedService } from '../../services/shared.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/interval';

@Component({
  selector: 'app-player',
  templateUrl: './player.component.html',
  styleUrls: ['./player.component.css']
})
export class PlayerComponent implements OnInit {
  playerId: string;
  playerDoc;
  playerObs;
  player;
  newBidValue: number;
  uid;
  clock;
  constructor(private route: ActivatedRoute,
              private router: Router,
              public sharedService: SharedService,
              private afs: AngularFirestore,
              public afAuth: AngularFireAuth) { }

  ngOnInit() {
    const that = this;
    this.clock = Observable.interval(1000).map(tick => new Date()).share();
    this.afAuth.authState.subscribe(user => {
      that.uid = user ? user.uid : null;
    });
    that.route.params.subscribe(params => {
      that.playerId = params.id;
      that.playerDoc = that.afs.doc('players/' + that.playerId);
      that.playerObs = that.playerDoc.valueChanges();
      that.player = that.playerObs.subscribe(player => {
        that.player = player;
      });
    });
  }

  newBid() {
    const bid = new Bid(this.uid, new Date().getTime(), this.newBidValue,
        this.sharedService.getPhaseForPlayer(this.player, new Date()));
    this.player.bids.push(bid);
    this.afs.collection('players').doc(this.playerId).update(JSON.parse(JSON.stringify(this.player)));
    this.router.navigate(['']);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/player/player.component.ts